import { render, staticRenderFns } from "./InternalObservationTable.vue?vue&type=template&id=4dc9571b"
import script from "./InternalObservationTable.vue?vue&type=script&lang=js"
export * from "./InternalObservationTable.vue?vue&type=script&lang=js"
import style0 from "./InternalObservationTable.vue?vue&type=style&index=0&id=4dc9571b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports